import { Suspense, lazy, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { updateFavicon } from './faviconUtils';
import {
  FORCE_LOGIN_COMPANY,
  getPathSegments,
  getStoredCompany,
} from './rootRouting';

const AppContainer = lazy(() => import('./AppContainer'));
const Dashboard = lazy(() => import('./dashboard/Dashboard'));

const domNode = document.getElementById('root');
const root = createRoot(domNode as HTMLElement);

const Root = () => {
  const [company, setCompany] = useState<string | null>(null);
  const [hash, setHash] = useState('');
  const [forceCompanySelector, setForceCompanySelector] = useState(false);

  useEffect(() => {
    const currCompany = getStoredCompany(localStorage.getItem('company'));
    let urlCompany = '';
    let isForm = false;
    let urlHash = '';

    if (/evisioncrm|localhost/.test(window.location.hostname)) {
      const splittedUrl = getPathSegments(window.location.pathname);
      urlCompany = splittedUrl[0] || '';
      isForm = splittedUrl[1] === 'form';
      urlHash = splittedUrl[2] || '';
    } else {
      const urls = window.location.hostname.split('.');
      urlCompany = urls[urls.length - 2];

      updateFavicon(urlCompany);
    }

    if (isForm) {
      setHash(urlHash);
    }

    const isForceLogin = urlCompany === FORCE_LOGIN_COMPANY;

    if (isForceLogin) {
      if (currCompany) {
        window.location.replace(`/${currCompany}`);
        return;
      }

      if (localStorage.getItem('company') === FORCE_LOGIN_COMPANY) {
        localStorage.removeItem('company');
      }

      setForceCompanySelector(true);
      setCompany(FORCE_LOGIN_COMPANY);
      return;
    }

    setForceCompanySelector(false);
    setCompany(urlCompany);

    if (urlCompany) {
      localStorage.setItem('company', urlCompany);
    }
  }, []);

  return hash || company ? (
    <Suspense fallback={null}>
      <AppContainer
        external={hash}
        forceCompanySelector={forceCompanySelector}
      />
    </Suspense>
  ) : company === null ? null : (
    <div style={{ overflow: 'auto' }}>
      <Suspense fallback={null}>
        <Dashboard />
      </Suspense>
    </div>
  );
};

root.render(<Root />);
